import { render, staticRenderFns } from "./CreateThumb.vue?vue&type=template&id=5a0d6e22&"
import script from "./CreateThumb.vue?vue&type=script&lang=js&"
export * from "./CreateThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports